import {
    Card,
    CardContent,
    CardMedia,
    Skeleton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import './shared.scss';
import * as React from "react";
import MealModal from './modals/meal-modal';
import IProduct from '../interfaces/IProduct';
import img from '../../public/assets/images/pizza-pulled-pork.jpeg'
import ICategory from '../interfaces/ICategory';
import useCheckMobileScreen from '../utils/detect-mobile-size';

export default function MealCard(props: { cart: IProduct[]; setCart: any; product: IProduct; addItem: (arg0: any) => void; isLoading: any; category: ICategory}) {
    const [open, setOpen] = React.useState(false);
    const cart = props.cart;
    const setCart = props.setCart;
    const product = props.product;
    const category = props.category;
    let isMobile = useCheckMobileScreen();


    const mealAmountCart = () => {
        let total = 0;
        cart.filter(prod => prod.id === product.id).map(prod =>
            total += prod.quantity
        );
        return total;
    }

    const handleClickOpen = () => {
        if (product.optionGroups.length > 0) {
            setOpen(true);
        } else {
            const newProduct: IProduct = {...product, quantity: 1}
            handleAdd(newProduct);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = (prod: IProduct) => {
        props.addItem(prod);
    }


    return (
        <Card className="meal-card">
            {props.isLoading ? <Skeleton variant="rectangular" width="100%" height={120} /> :
                product.image &&
                <CardMedia
                    onClick={handleClickOpen}
                    className="img-card"
                    component="img"
                    sx={{
                        height: category.gridColumns! > 3 ? 90 : 140,
                        width: isMobile ? 100 : 'auto',
                        maskImage: isMobile ? 'linear-gradient(to right, rgba(0, 0, 0, 1.0) 75%, transparent 100%)' : ''
                }}
                    image={`${process.env.PUBLIC_URL}/assets/images/${product.image}`}
                    alt={product.description}
                />
            }
            <CardContent className="card-content" onClick={handleClickOpen}>
                <div>
                    <div className='text-base font-bold pr-6'>{product.name}</div>
                    <div className="text-sm text-gray-500">
                        {product.description}
                    </div>
                </div>
                <div className="tracking-wide mt-auto font-bold">
                    € {product.price.toFixed(2).replace(".", ",")}
                </div>
            </CardContent>
            <div className="absolute top-2 right-2" onClick={handleClickOpen}>
                <button className="action-button rounded-full p-1" aria-label="add to favorites">
                    {mealAmountCart()! > 0 ? <div className="meal-amount">{mealAmountCart()}</div> : <AddIcon /> }
                </button>
            </div>
            {open ?
                <MealModal
                    open={open}
                    //@ts-ignore
                    isEditing={false}
                    onAdd={handleAdd}
                    onClose={handleClose}
                    product={product}
                    setCart={setCart}
                    cart={cart} />
            : null}
        </Card>
    )
}
